module.exports = __webpack_public_path__ + "img/3.395a8d70.png";